const adapt = httpResponse => {
  const { usuario, nome, empresa, site, fornecedor, userSession } = httpResponse.data;
  return {
    ...httpResponse,
    userSession: {
      usuario: {
        id: usuario,
        name: nome,
      },
      // API response doesn't provide separate company/unit display names here,
      // so we don't fabricate one by reusing the user's name (previous bug).
      empresa: {
        id: empresa,
      },
      unidade: {
        id: site,
        empresaId: empresa,
      },
      providerId: fornecedor,
      permissoesList: userSession?.permissoesList || [],
    },
  };
};

const refreshAdapter = httpResponsePromise =>
  httpResponsePromise.then(
    resolve => adapt(resolve),
    reject => reject,
  );

export { refreshAdapter };
